// extracted by mini-css-extract-plugin
export default {"container":"CampaignRestrictionsSpecialModeEdit_container__+FWG4","wrapperInput":"CampaignRestrictionsSpecialModeEdit_wrapperInput__o+LOJ"};